// @ts-strict-ignore
import * as React from 'react';
import CommonNotificationSettingsModal from '../sharedComponents/CommonNotificationSettingsModal';
import { tryUpdateAppSettings, UpdateNotificationSettingsRequest } from '../../actions/appSettings';
import { useDispatch, useSelector } from 'react-redux';
import { AppSettingsUpdatable } from '../../actions/updatable';
import { RootState } from '../../reducers/reducers';
import { selectCommonNotificationFromAppNotificationId } from '../../selectors/selectors';
import { AppComponentProps } from '../../typescriptHelpers';
import { AppNotificationType } from '../../types';
import { dayjs } from '@/extendedDayjs';

interface NotificationSettingsModalProps extends AppComponentProps {
    notificationId: AppNotificationType;
    onClose: () => void;
    onAfterClose: () => void;
    open: boolean;
}

const NotificationSettingsModal: React.FC<NotificationSettingsModalProps> = (props: NotificationSettingsModalProps) => {
    const dispatch = useDispatch();

    const onSubmit = (values: any) => {
        const hourOfDay = values.hourOfDay ? dayjs(values.hourOfDay, 'HH:mm').clone().utc().hour() : null;
        const request: UpdateNotificationSettingsRequest = {
            orgId: props.orgId,
            appId: props.appId,
            notificationId: props.notificationId,
            hourOfDayForNotification: hourOfDay,
            appleProfileAndCertificateReminderDaysBeforeExpiration:
                values.appleProfileAndCertificateReminderDaysBeforeExpiration,
            bundleSizeIncreaseConditions: values.bundleSizeIncreaseConditions,
            bundleSizeCellularDownloadLimitThresholdMB: values.bundleSizeCellularDownloadLimitThresholdMB,
            bundleSizeAlertNotifyFor: values.bundleSizeAlertNotifyFor,
            ...values,
        };

        dispatch(tryUpdateAppSettings(AppSettingsUpdatable.UpdateNotificationSetting, request, props.notificationId));
    };

    const notification = useSelector((state: RootState) =>
        selectCommonNotificationFromAppNotificationId(state, props.appId, props.notificationId),
    );

    return (
        <CommonNotificationSettingsModal
            onSubmit={onSubmit}
            actionType={AppSettingsUpdatable.UpdateNotificationSetting}
            notification={notification}
            {...props}
        />
    );
};

export default NotificationSettingsModal;
